// TODO SelectHierarchicalMenuDialogに置き換えたい。
import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import DialogModal from '../../../../common/DialogModal';
import Toolbar from 'material-ui/Toolbar';
import { DialogTitle } from 'material-ui/Dialog';
import Checkbox from 'material-ui/Checkbox';
import Button from '../../../../Parts/Button';
import Trend from '../../../../Icons/Trend';

const { Map, Set } = require('immutable');

const styles = () => ({
  paper: {
    background: "#F4F6F9",
    width: '85%',
    maxHeight: 'unset',
  },

  contentContainer: {
    margin: '0px',
    padding: '0px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    textAlign: 'left',
    position: 'relative',
    boxSizing: 'border-box',
  },

  guttersContainer: {
    width: '100%',
    zIndex: 2,
  },

  gutters: {
    background: "#FFFFFF",
    fontSize: "15px",
    fontWeight: 700,
    borderBottom: "1px solid #D8DBDF",
    width: '100%',
    boxSizing: 'border-box',
    position: 'sticky',
    top: 0,
    zIndex: 1,
  },

  dialogTitle: {
    padding: '0px',
    flex: 1,
  },

  containerWrapper: {
    width: '100%',
    padding: '25px',
    boxSizing: 'border-box',
  },

  container: {
    background: '#FFFFFF',
    border: '1px solid #D8DBDF',
    width: '100%',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '20px 20px 10px',
  },

  row: {
    padding: '22px 0px',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    borderBottom: '1px solid #D8DBDF',
    boxSizing: 'border-box',
    color: '#181819',
  },

  title: {
    background: '#F4F6F9',
    width: '100%',
    padding: '12px 10px',
    boxSizing: 'border-box',
    textAlign: 'left',
    fontSize: '13px',
    color: '#5A5B62',
    display: 'flex',
    alignItems: 'center',
  },

  section: {
    width: '100%',
  },

  sectionContainer: {
    width: '100%',
    boxSizing: 'border-box',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'flex-start',
    padding: '12px'
  },

  item: {
    textAlign: 'left',
    paddingTop: '10px',
    display: 'flex',
    alignItems: 'center',
  },

  text: {
    fontSize: '13px',
    color: '#181819',
    textOverflow: 'ellipsis',
    display: 'inline-block',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    cursor: 'pointer'
  },

  label: {
    fontWeight: "bold",
    fontSize: "8px",
    background: "#FFC62B",
    color: "#FFFFFF",
    padding: "1px 4px",
    marginLeft: "5px",
    whiteSpace: "nowrap",
    borderRadius: "3px",
  },
});

class SelectNestedMenuDialog extends React.Component {
  state = {
    selectedItems: Map(),
  }

  componentWillMount() {
    this.setState({
      selectedItems: this.props.set,
    });
  }

  componentWillReceiveProps(nextProps) {
    if (!this.state.selectedItems.equals(nextProps.set)) {
      this.setState({
        selectedItems: nextProps.set,
      });
    }
  }

  handleScroll = () => {
    const maxScrollTop = 20;
    if (this.contentRef && this.titleRef && this.contentRef.scrollTop > maxScrollTop) {
      this.titleRef.style.boxShadow = '0px 1px 10px 0px rgba(0, 0, 0, 0.12)';
    } else {
      this.titleRef.style.boxShadow = 'none'
    }
  }

  setTitleRef = (node) => {
    this.titleRef = node;
  }

  setContentRef = (node) => {
    this.contentRef = node;
    if (this.contentRef) {
      this.contentRef.addEventListener('scroll', this.handleScroll, false);
    }
  }

  selectMenu = value => () => {
    let selectedItems = this.state.selectedItems;

    if (selectedItems.has(value)) {
      selectedItems = selectedItems.delete(value);
    } else {
      let submenu = Set();
      let entry = this.props.nestedMenu.find(item => item.value === value);

      if (entry) {
        entry.submenu.forEach(item => {
          submenu = submenu.add(item.value);
        })
      }

      selectedItems = selectedItems.set(value, submenu);
    }

    this.setState({
      selectedItems: selectedItems,
    })
  }

  selectSubmenu = (parentValue, childValue) => () => {
    let parent = this.state.selectedItems;
    let children = parent.get(parentValue);

    if (childValue === undefined || !children) {
      children = Set();
    }

    if (children.has(childValue)) {
      children = children.delete(childValue);
    } else {
      children = children.add(childValue);
    }

    if (children.size === 0) {
      parent = parent.delete(parentValue);
    } else {
      parent = parent.set(parentValue, children);
    }

    this.setState({
      selectedItems: parent,
    })
  }

  render() {
    const { classes, toggleDialog, isOpen, title, nestedMenu, colCount, getItemTextStyle } = this.props;
    const { selectedItems } = this.state;

    // 列の幅を計算 (全列均等)
    // eslint-disable-next-line no-magic-numbers
    const itemWidth = `${100 / colCount}%`;

    return (
      <DialogModal
        open={isOpen}
        onClose={toggleDialog}
        maxWidth={false}
        classes={{
          paper: classes.paper,
          contentContainer: classes.contentContainer
        }}
      >
        <div ref={this.setTitleRef} className={classes.guttersContainer}>
          <Toolbar classes={{ gutters: classes.gutters }}>
            <DialogTitle className={classes.dialogTitle} disableTypography>
              {title}
            </DialogTitle>

            <Button
              text="条件をセット"
              handleClickButton={() => {
                this.props.save(selectedItems)
                toggleDialog()
              }}
              size="small"
              disabled={this.state.selectedItems.equals(this.props.set)}
            />
          </Toolbar>
        </div>
        <div className={classes.containerWrapper} ref={this.setContentRef}>
          <div className={classes.container}>
            {nestedMenu.map((category, i) => (
              <div className={classes.section} key={i}>
                <div className={classes.title}>
                  <Checkbox
                    color="primary"
                    checked={selectedItems.has(category.value)}
                    style={{
                      width: '15px',
                      height: '15px',
                      marginRight: '8px'
                    }}
                    value={category.value.toString()}
                    onChange={this.selectMenu(category.value.toString())}
                  />
                  {category.value === 'trend' && <Trend style={{ marginRight: '3px' }} />}
                  <div className={classes.text} style={{ color: '#5A5B62' }} onClick={this.selectMenu(category.value.toString())}>
                    {category.name || category.value}
                  </div>
                </div>
                <div className={classes.sectionContainer}>
                  {category.submenu.map((item, j) => {
                    // 呼び出し側 (SelectInvestBusinessAreaDialog 等) で、特定グループの特定カラムだけ
                    // テキスト要素のスタイルを上書きしたい場合に使う (はみ出し許容など)。
                    // 戻り値 null/undefined のときは既定スタイル (classes.text) のみが適用される。
                    const textStyleOverride = getItemTextStyle && getItemTextStyle(category, j, colCount);
                    return (
                    <div className={classes.item} key={j} style={{ width: itemWidth }}>
                      <div>
                        <Checkbox
                          color="primary"
                          checked={selectedItems.has(category.value) && selectedItems.get(category.value).includes(item.value)}
                          style={{
                            width: '15px',
                            height: '15px',
                            marginRight: '5px'
                          }}
                          value={item.value.toString()}
                          onChange={this.selectSubmenu(category.value.toString(), item.value.toString())}
                        />
                      </div>
                      <div
                        className={classes.text}
                        style={textStyleOverride || undefined}
                        title={item.value}
                        onClick={this.selectSubmenu(category.value.toString(), item.value.toString())}
                      >
                        {item.name || item.value}
                      </div>
                      {/* 抽象化した条件付きラベル表示 */}
                      {this.props.contextData && this.props.contextData.shouldShowLabel &&
                        this.props.contextData.shouldShowLabel(item) && (
                        <div className={classes.label}>
                          {this.props.contextData.labelText || "NEW"}
                        </div>
                      )}
                    </div>
                  );
                  })}
                </div>
              </div>
            ))}
          </div>
        </div>
      </DialogModal>
    );
  }
}

SelectNestedMenuDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  toggleDialog: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  set: PropTypes.object,
  save: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  nestedMenu: PropTypes.array.isRequired,
  contextData: PropTypes.object,
  colCount: PropTypes.number,
  // (category, itemIndex, colCount) => CSSProperties | null
  // 特定グループ・特定カラムのテキスト要素 (className=classes.text) のインラインスタイルを
  // 上書きする際に使用する。列幅は不変のため、チェックボックスの縦位置は揃ったまま。
  // 戻り値 null/undefined のときは既定スタイル (text-overflow: ellipsis 等) のみが適用される。
  getItemTextStyle: PropTypes.func,
};

SelectNestedMenuDialog.defaultProps = {
  // eslint-disable-next-line no-magic-numbers
  colCount: 4,
};

export default withStyles(styles)(SelectNestedMenuDialog);



// WEBPACK FOOTER //
// ./src/components/ExecutiveList/dialogs/SelectNestedMenuDialog/common/SelectNestedMenuDialog.jsx